/**
 * send_mobile_otp function used to send mobile otp
 * @returns {undefined}
 */
function send_mobile_otp()
{
    $("#mobile_no, #send_otp_btn").hide();
    $("#mobile_opt, #confirm_mobile_opt_btn").show();
}

/**
 * send_mobile_otp function used to send mobile otp
 * @returns {undefined}
 */

/**
 * open_forgot_pass_popup function used to open forgot password popup
 * @returns {undefined}
 */
function open_forgot_pass_popup()
{
    $("#login-popup").modal('hide');
    $("#forgot-password-popup").modal('show');
}

/**
 * close_forgot_pass_open_join_popup function used to close forgot password popup and open join us popup
 * @returns {undefined}
 */
function close_forgot_pass_open_join_popup()
{
    $("#forgot-password-popup").modal('hide');
    $("#login-popup").modal('show');    
}

/**
 * show_hide_div function used to show hide divs
 * @param {type} hide_ids
 * @param {type} show_ids
 * @returns {undefined}
 */
function show_hide_div(hide_ids, show_ids)
{
    if(hide_ids!=="")
    {
        $(hide_ids).hide();
    }
    if(show_ids!=="")
    {
        $(show_ids).show();
    }
}

/**
 * content_hide_div function used to show as content and  hide divs
 * @param {type} hide_ids
 * @param {type} show_ids
 * @returns {undefined}
 */
function content_hide_div(hide_ids, show_ids)
{
    if(hide_ids!=="")
    {
        $(hide_ids).hide();
    }
    if(show_ids!=="")
    {
        $(show_ids).show();
        $(show_ids).css("display","contents");
    }
}

function getFields(x){
    if(x.value == "1"){
      $("#individual-block").show();
      $("#proprietorship-block").hide();
         $("#partnership-block").hide();
          $("#llp-block").hide();
         $("#plc-block").hide();
    } else if(x.value == "2"){
      $("#individual-block").hide();
      $("#proprietorship-block").show();
         $("#partnership-block").hide();
          $("#llp-block").hide();
         $("#plc-block").hide();
    } else if(x.value == "3"){
      $("#individual-block").hide();
      $("#proprietorship-block").hide();
         $("#partnership-block").show();
          $("#llp-block").hide();
         $("#plc-block").hide();
    } else if(x.value == "4"){
      $("#individual-block").hide();
      $("#proprietorship-block").hide();
         $("#partnership-block").hide();
          $("#llp-block").show();
         $("#plc-block").hide();
    } else if(x.value == "5"){
      $("#individual-block").hide();
      $("#proprietorship-block").hide();
         $("#partnership-block").hide();
          $("#llp-block").hide();
         $("#plc-block").show();
    } else{
      $("#individual-block").hide();
      $("#proprietorship-block").hide();
         $("#partnership-block").hide();
          $("#llp-block").hide();
         $("#plc-block").hide();
    }
}

$(document).ready(function(){
         $("#individual-block").hide();
          $("#proprietorship-block").hide();
         $("#partnership-block").hide();
          $("#llp-block").hide();
         $("#plc-block").hide();
});


/** reset_slider function used to reset slider */
function reset_slider(val)
{
    var owl = $(val);
	owl.owlCarousel({
		margin: 5,
		loop: true,
		nav: true,
		autoplay: true,
		dots: false,
		responsive: {
			0: {
				items: 1
			},
			600: {
				items: 2
			},
			1000: {
				items: 5
			}
		}
	});  
}

/** reset_slider2 function used to reset slider */
function reset_slider2(val)
{
    var owl = $(val);
	owl.owlCarousel({
		margin: 5,
		loop: true,
		nav: true,
		autoplay: true,
		dots: false,
		responsive: {
			0: {
				items: 1
			},
			600: {
				items: 2
			},
			1000: {
				items: 3
			}
		}
	});  
}

/** reset_slider3 function used to reset slider */
function reset_slider3(val)
{
    var owl = $(val);
	owl.owlCarousel({
		margin: 25,
		loop: true,
		nav: true,
		autoplay: true,
		dots: false,
		responsive: {
			0: {
				items: 1
			},
			600: {
				items: 2
			},
			1000: {
				items: 3
			}
		}
	}); 
}

/** reset_slider4 function used to reset slider */
function reset_slider4(val)
{
    var owl = $(val);
	owl.owlCarousel({
		margin: 25,
		loop: true,
		nav: true,
		autoplay: true,
    autoplayTimeout: 10000,
    smartSpeed: 3000,     
		dots: false,
		responsive: {
			0: {
				items: 1
			},
			600: {
				items: 1
			},
			1300: {
				items: 1
			}
		}
	}); 
}

	

        function hide_trade_entity_box()
        {
         $("#individual-block2").hide();
          $("#proprietorship-block2").hide();
         $("#partnership-block2").hide();
          $("#llp-block2").hide();
         $("#plc-block2").hide();
         }

         function getFields2(x){
    if(x.value == "1"){
      $("#individual-block2").show();
      $("#proprietorship-block2").hide();
         $("#partnership-block2").hide();
          $("#llp-block2").hide();
         $("#plc-block2").hide();
    } else if(x.value == "2"){
      $("#individual-block2").hide();
      $("#proprietorship-block2").show();
         $("#partnership-block2").hide();
          $("#llp-block2").hide();
         $("#plc-block2").hide();
    } else if(x.value == "3"){
      $("#individual-block2").hide();
      $("#proprietorship-block2").hide();
         $("#partnership-block2").show();
          $("#llp-block2").hide();
         $("#plc-block2").hide();
    } else if(x.value == "4"){
      $("#individual-block2").hide();
      $("#proprietorship-block2").hide();
         $("#partnership-block2").hide();
          $("#llp-block2").show();
         $("#plc-block2").hide();
    } else if(x.value == "5"){
      $("#individual-block2").hide();
      $("#proprietorship-block2").hide();
         $("#partnership-block2").hide();
          $("#llp-block2").hide();
         $("#plc-block2").show();
    } else{
      $("#individual-block2").hide();
      $("#proprietorship-block2").hide();
         $("#partnership-block2").hide();
          $("#llp-block2").hide();
         $("#plc-block2").hide();
    }    
}

function hide_trade_entity_box2()
        {
         $("#individual-block").hide();
          $("#proprietorship-block").hide();
         $("#partnership-block").hide();
          $("#llp-block").hide();
         $("#plc-block").hide();
         }

function set_my_preference_price_range(from,to)
{
  $("#pre_range").ionRangeSlider({
	type: "double",
	min: 5000,
	max: 9900000,
	grid: true,
	force_edges: true,
	step: 10,
	prettify_enabled: true,
	prettify_separator: ",",
	skin: "round",
  from:from,
  to:to,
	onStart: function (data) {
            // Called every time handle position is changed  
			setTimeout(function() {
		    $("#pre_range_from").val(data.from);
			$("#pre_range_to").val(data.to);	
			}, 500);			
        },	
	onFinish: function (data) {		
            // Called then action is done and mouse is released
		    $("#pre_range_from").val(data.from);
			$("#pre_range_to").val(data.to);
        },
});
}   

function changeButton(){
			
		    var fromYear = parseInt(document.querySelector('#fromYearSelect').value);
		    var toYear = parseInt(document.querySelector('#toYearSelect').value);
			var bt = fromYear+"-"+toYear;
			 na = document.querySelector("#btn1").innerHTML = bt;
			 $("#fromYearSelect").hide();
       $("#toYearSelect").hide();
		}
		
		
        function updateYear(){
            var fromYearSelect =   document.getElementById('toYearSelect');
            var toYear = parseInt(document.querySelector('#fromYearSelect').value);
          
           	
            document.querySelector('#toYearSelect').options.length = 0;
            for(let x=toYear;x<=2020;x++){
                var option = document.createElement("option");
                option.text = x;
                option.value = x;
                fromYearSelect.add(option);
                
            }            
        }
        

        function myFunction() {
        	  var x = document.getElementById("fromYearSelect");
        	  var y = document.getElementById("toYearSelect");
          	
        	  
        	  if (x.style.display == "none") {
        	    x.style.display = "block";
        	  } else {
        	    x.style.display = "none";
        	  }

        	  if (y.style.display == "none") {
        	    y.style.display = "block";
        	  } else {
        	    y.style.display = "none";
        	  }
        	 
        }

        /** set_signup_range_from_to function used to set signup range from to  */
        function set_signup_range_from_to()
        {
          $("#reg_range_from").ionRangeSlider({
          type: "double",
          min: 5000,
          max: 9900000,
          grid: true,
          force_edges: true,
          step: 10,
          prettify_enabled: true,
          prettify_separator: ",",
          skin: "round",
          onStart: function (data) {
                    // Called every time handle position is changed  
              setTimeout(function() {
                $("#reg_range_from").val(data.from);
              $("#reg_range_to").val(data.to);	
              }, 500);			
                },	
          onFinish: function (data) {		
                    // Called then action is done and mouse is released
                $("#reg_range_from").val(data.from);
              $("#reg_range_to").val(data.to);
                },
        });
        }

        /** cars_list_price_from_to function used to set price range on car list page  */
        function cars_list_price_from_to()
        {
          $("#cars_list_price_range").ionRangeSlider({
          type: "double",
          min: 5000,
          max: 9900000,
          // grid: true,
          // force_edges: true,
          // step: 10,
          prettify_enabled: true,
          prettify_separator: ",",
          skin: "round",
          onStart: function (data) {
                    // Called every time handle position is changed  
              setTimeout(function() {
                $("#cars_list_price_range_from").val(data.from);
              $("#cars_list_price_range_to").val(data.to);	
              }, 500);			
                },	
          onFinish: function (data) {		
                    // Called then action is done and mouse is released
                $("#cars_list_price_range_from").val(data.from);
              $("#cars_list_price_range_to").val(data.to);
                },
        });
        }


        /** cars_list_km_driven_from_to function used to set km driven range on car list page  */
        function cars_list_km_driven_from_to()
        {
          $("#cars_list_km_driven_range").ionRangeSlider({
          type: "double",
          min: 0,
          max: 1000000,
        //  grid: true,
        //  force_edges: true,
         // step: 10000,
         prettify_enabled: true,
          prettify_separator: ",",
          skin: "round",
          onStart: function (data) {
                    // Called every time handle position is changed  
              setTimeout(function() {
                $("#cars_list_km_driven_range_from").val(data.from);
              $("#cars_list_km_driven_range_to").val(data.to);	
              }, 500);			
                },	
          onFinish: function (data) {		
                    // Called then action is done and mouse is released
                $("#cars_list_km_driven_range_from").val(data.from);
              $("#cars_list_km_driven_range_to").val(data.to);
                },
        });
        }

        /** cars_list_year_from_to function used to set km driven range on car list page  */
        function cars_list_year_from_to()
        {
          $("#cars_list_year_range").ionRangeSlider({
          type: "double",
          min: 1995,
          max: 2020,
          // grid: true,
          // force_edges: true,
          // step: 10,
          prettify_enabled: true,
          prettify_separator: ",",
          skin: "round",
          onStart: function (data) {
                    // Called every time handle position is changed  
              setTimeout(function() {
                $("#cars_list_year_range_from").val(data.from);
              $("#cars_list_year_range_to").val(data.to);	
              }, 500);			
                },	
          onFinish: function (data) {		
                    // Called then action is done and mouse is released
                $("#cars_list_year_range_from").val(data.from);
              $("#cars_list_year_range_to").val(data.to);
                },
        });
        }

        function show_joinus_preference_input()
        {
          $(".dev_pref").show();
        }

        function show_hide_inspection_detail()
        {
          $(".click-show").click(function() {
    if ($('.inspection-heading').is(':visible')) {
      $(".inspection-heading").slideUp(300);
      $(".plusminus").text('+');
    }
    if ($(this).next(".inspection-heading").is(':visible')) {
      $(this).next(".inspection-heading").slideUp(300);
      $(this).children(".plusminus").text('+');
    } else {
      $(this).next(".inspection-heading").slideDown(300);
      $(this).children(".plusminus").text('-');
    }
  });
        }

        function set_multi_select()
        {
          $('#preferred_state').multiselect({              
            enableCaseInsensitiveFiltering: true,
            onChange: function(element, checked) {
        var brands = $('#preferred_state option:selected');
        var selected = [];
        $(brands).each(function(index, brand){
            selected.push([$(this).val()]);
        });

       $('#selected_preferred_state').val(selected);
            }
 });  
 setTimeout(function() { 
 $(".input-group").css("margin", "0px");
 $(".multiselect-container input[type=checkbox]").css("opacity", "1"); 
 $(".multiselect-container").css("max-height", "350px");   
 $(".multiselect-container").css("overflow", "auto");   
 $('.multiselect-container .input-group-addon').remove();
 $('.multiselect-container .input-group-btn').remove();  
 var brands = $('#preferred_state option:selected');
        var selected = [];
        $(brands).each(function(index, brand){
            selected.push([$(this).val()]);
        });

       $('#selected_preferred_state').val(selected);
 }, 300);
    
        }

        function set_multi_select2()
        {
          $('#preferred_state2').multiselect({              
            enableCaseInsensitiveFiltering: true,
            onChange: function(element, checked) {
        var brands = $('#preferred_state2 option:selected');
        var selected = [];
        $(brands).each(function(index, brand){
            selected.push([$(this).val()]);
        });

       $('#selected_preferred_state2').val(selected);
            }
 });  
 setTimeout(function() { 
 $(".input-group").css("margin", "0px");
 $(".multiselect-container input[type=checkbox]").css("opacity", "1"); 
 $(".multiselect-container").css("max-height", "350px");   
 $(".multiselect-container").css("overflow", "auto");   
 $('.multiselect-container .input-group-addon').remove();
 $('.multiselect-container .input-group-btn').remove();  
 var brands = $('#preferred_state2 option:selected');
        var selected = [];
        $(brands).each(function(index, brand){
            selected.push([$(this).val()]);
        });

       $('#selected_preferred_state2').val(selected);
 }, 300);
    
        }

       function sell_car_reg_year()
       {
         $( "#sell_car_reg_year" ).datepicker(
      { 
        minViewMode: 'years',
        //autoclose: true,
        dateFormat: 'yyyy',
        //maxDate: new Date(),
        //changeYear: true,
        //changeMonth: true,
        yearRange: "-50:+0",
      }
    );
       }

      // $(document).ready(function(){
    
// When the user scrolls the page, execute myFunction
//window.onscroll = function() {myFunction()};

// Get the header
//var header = document.getElementById("header-main");

// Get the offset position of the navbar
//var sticky = header.offsetTop;

// Add the sticky class to the header when you reach its scroll position. Remove "sticky" when you leave the scroll position
//function myFunction() {
  //if (window.pageYOffset > sticky) {
  //  header.classList.add("sticky");
  //} else {
  //  header.classList.remove("sticky");
  //}
//}
  //});

  function stickyHeader() {
	  // When the user scrolls the page, execute myFunction
window.onscroll = function() {createStickyHeader()};

// Get the header
var header = document.getElementById("header-main");

// Get the offset position of the navbar
var sticky = header.offsetTop;

// Add the sticky class to the header when you reach its scroll position. Remove "sticky" when you leave the scroll position
function createStickyHeader() {
  if (window.pageYOffset > sticky) {
    header.classList.add("sticky");
  } else {
    header.classList.remove("sticky");
  }
}
  }

function set_horizontal_menu()
{
//jQuery(document).ready(function(){
//$("#horizontal-navtoggle").click(function(){
//  $("body").addClass("active");
//});
//$(".outsidebg").click(function(){
//  $("body").removeClass("active");
//});
//$(".close-cl").click(function(){
 // $("body").removeClass("active");
//});
//}); 

'use strict';
	document.addEventListener("touchstart", function() {}, false);
 	jQuery(function() {
 		jQuery('body').wrapInner('<div class="horizontalMenucontainer" />');
 		jQuery('<div class="outsidebg"></div>').prependTo('.horizontalMenu');
 		jQuery('#horizontal-navtoggle').click(function() {
			jQuery('body').toggleClass('active');
 		});
 		jQuery('.outsidebg').click(function() {
 			jQuery("body").removeClass('active');
 		});
 		jQuery('.horizontalMenu > .horizontalMenu-list > li').has('.sub-menu').prepend('<span class="horizontalMenu-click"><i class="horizontalMenu-arrow fa fa-angle-down"></i></span>');
 		jQuery('.horizontalMenu > .horizontalMenu-list > li').has('.horizontal-megamenu').prepend('<span class="horizontalMenu-click"><i class="horizontalMenu-arrow fa fa-angle-down"></i></span>');
 		jQuery('.horizontalMenu-click').click(function() {
 			jQuery(this).toggleClass('current-arrow').parent().siblings().children().removeClass('current-arrow');
 			jQuery(".horizontalMenu > .horizontalMenu-list > li > .sub-menu, .horizontal-megamenu").not(jQuery(this).siblings('.horizontalMenu > .horizontalMenu-list > li > .sub-menu, .horizontal-megamenu')).slideUp('slow');
 			jQuery(this).siblings('.sub-menu').slideToggle('slow');
 			jQuery(this).siblings('.horizontal-megamenu').slideToggle('slow');
		});
 		jQuery('.horizontalMenu > .horizontalMenu-list > li > ul > li').has('.sub-menu').prepend('<span class="horizontalMenu-click02"><i class="horizontalMenu-arrow fa fa-angle-down"></i></span>');
 		jQuery('.horizontalMenu > .horizontalMenu-list > li > ul > li > ul > li').has('.sub-menu').prepend('<span class="horizontalMenu-click02"><i class="horizontalMenu-arrow fa fa-angle-down"></i></span>');
 		jQuery('.horizontalMenu-click02').click(function() {
 			jQuery(this).children('.horizontalMenu-arrow').toggleClass('horizontalMenu-rotate');
 			jQuery(this).siblings('li > .sub-menu').slideToggle('slow');
 		});
 		jQuery(window).on('resize', function() {
 			if (jQuery(window).outerWidth() < 992) {
 				jQuery('.horizontalMenu').css('height', jQuery(this).height() + "px");
 				jQuery('.horizontalMenucontainer').css('min-width', jQuery(this).width() + "px");
 			} else {
 				jQuery('.horizontalMenu').removeAttr("style");
 				jQuery('.horizontalMenucontainer').removeAttr("style");
 				jQuery('body').removeClass("active");
 				jQuery('.horizontalMenu > .horizontalMenu-list > li > .horizontal-megamenu, .horizontalMenu > .horizontalMenu-list > li > ul.sub-menu, .horizontalMenu > .horizontalMenu-list > li > ul.sub-menu > li > ul.sub-menu, .horizontalMenu > .horizontalMenu-list > li > ul.sub-menu > li > ul.sub-menu > li > ul.sub-menu').removeAttr("style");
 				jQuery('.horizontalMenu-click').removeClass("current-arrow");
 				jQuery('.horizontalMenu-click02 > i').removeClass("horizontalMenu-rotate");
 			}
 		});
 		jQuery(window).trigger('resize');
 	});
	$(".close-cl").click(function(){
  $("body").removeClass("active");
});
}

function addBootStrapPagination(id)
{
  $('#'+id).DataTable();
}

/** manage_show_hide_inspection_detail function used to manage show hide of inspection detail  */
function manage_show_hide_inspection_detail()
{
  $(".click-show").click(function() {
    if ($('.inspection-heading').is(':visible')) {
      $(".inspection-heading").slideUp(300);
      $(".plusminus").text('+');
    }
    if ($(this).next(".inspection-heading").is(':visible')) {
      $(this).next(".inspection-heading").slideUp(300);
      $(this).children(".plusminus").text('+');
    } else {
      $(this).next(".inspection-heading").slideDown(300);
      $(this).children(".plusminus").text('-');
    }
  });
}

/** manage_show_hide_inspection_detail function used to manage show hide of inspection detail  */
function slide_up(id_class)
{     if(id_class==".inspection-heading")
      {
      $(".inspection-heading").slideUp(300);
      $(".plusminus").text('+');  
      }  
}

/** add_select_box_design_class function used to add design on select */
function add_select_box_design(class_name)
{
  $(class_name).select2({
	 minimumResultsForSearch: '',
	 placeholder: "Search"
   });
}

/** set_min_date function used to set minimum date today date */
function set_min_date(id) {
    var now = new Date();

    var day = ("0" + now.getDate()).slice(-2);
    var month = ("0" + (now.getMonth() + 1)).slice(-2);

    var today = now.getFullYear() + "-" + (month) + "-" + (day);

    $('#'+id).attr('min', today); 
    }

/** set_max_date function used to set max date today date */
function set_max_date(id) {
    var now = new Date();

    var day = ("0" + now.getDate()).slice(-2);
    var month = ("0" + (now.getMonth() + 1)).slice(-2);

    var today = now.getFullYear() + "-" + (month) + "-" + (day);

    $('#'+id).attr('max', today); 
    }    

/** show_img function used to show inspection image  */
function show_img(img_url)
{ 
   $('#inspection_pic_id').attr('src', img_url);   
   $('#inspection_pic_modal').modal('show');
}

/** show_img function used to show 2 inspection image  */
function show_img2(img_url1,img_url2)
{ 
   $('#inspection_pic_id1').attr('src', img_url1);
   $('#inspection_pic_id2').attr('src', img_url2);   
   $('#inspection_pic_modal2').modal('show');
}

/** function used to copy content from id */
function copyFromId(id)
{
  /* Get the text field */
    var copyText = document.getElementById(id);

    /* Select the text field */
    copyText.select();

    /* Copy the text inside the text field */
    document.execCommand("copy");

    /* Alert the copied text */
    //show_foodiee_alert("Copied the text: " + copyText.value);
}

/** hide_modal function used to hide modal */
function hide_modal(id)
{
  $("#"+id).modal("hide");
}

/** hide_show_payment_type function used to hide show payment type */
function hide_show_payment_type()
{
  $(".click-rediotop").click(function(){
    $(".depoitfor").hide();
  });
  $(".click-rediotop").click(function(){
    $(".topupmy ").show();
  });
   $(".click-rediopur").click(function(){
    $(".topupmy").hide();
  });
  $(".click-rediopur").click(function(){
    $(".depoitfor ").show();
  });
}



	